import { Typography } from '@mui/material';
import ButtonWithSpinner from '../../../../../components/buttons/ButtonWithSpinner';
import './OffButtonForm.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  label: '',
  loading: false,
  handleOnClick: () => {},
};

const OffButtonForm = (p) => {
  const { label, loading, handleOnClick, ...rest } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div {...rest} className='off-button-form'>
      <div className='label-container' data-url='set-to-aff-label'>
        <Typography variant='subtitle1' className='label'>
          Set All {label} to Off
        </Typography>
      </div>
      <div className='off-button'>
        <ButtonWithSpinner data-url='set-to-aff-action' loading={loading} className='off-button' label='OFF' onClick={handleOnClick} />
      </div>
    </div>
  );
};

export default OffButtonForm;
